import {
  MarketplaceAccountLiteResponse,
  MarketplaceAccountResponse,
} from '../../../Models/marketplaceAccountModel';
import { MarketplaceCategoriesResponse } from '../../../Models/MarketplaceCategoryModel';
import { MarketplaceAttributeResponse } from '../../product/models/product.model';

export class BasePostingProfileRequest {
  id: number = 0;
  name: string = '';
  description: string = '';
  status: number = 2;
  statusName: string = '';
  endOfAuctionActionName: string = '';
  auctionPaymentDueOptionName: string = '';
  statusId: boolean = true;
  repeatNoOfTimesIfUnsold: any = 0;
  auctionPaymentDueOption: number = 0;
  endOfAuctionAction: number = 0;
  companyId: number = 0;
  handlingCharges: any = 0;
  canOverrideHandlingCharges: boolean = false;
  salesFloorPrice: any;
  canOverrideFloorPrice: boolean = false;
  source: number = 1;
  rules: BasePostingProfileRules[] = [];
}

export class CreatePostingProfileRequest extends BasePostingProfileRequest {}

export class PostingProfileResponse extends BasePostingProfileRequest {
  createdAt: Date = new Date();
  createdById: number = 0;
  lastModifiedAt: Date = new Date();
  lastModifiedById: number = 0;
}
export class BasePostingProfileRules {
  id: number = 0;
  type: number = 1;
  typeName: string = '';
  marketplace: number = 0;
  marketplaceName: string = '';
  carrierId: number = 0;
  canOverrideCarrier: boolean = false;
  marketplaceAttributes: MarketplaceAttributeResponse[] = [];
  marketplaceAccounts: MarketplaceAccountLiteResponse[] = [];
  marketplaceAccount: MarketplaceAccountLiteResponse =
    new MarketplaceAccountResponse();
  marketplaceAccountId: number | null = null;
  postingProfileId: number = 0;
  auctionStartOption: number = 0;
  auctionStartOptionName: string = '';
  auctionDurationInDays: any;
  startingBid: any = 0;
  canOverrideStartingBid: boolean = false;
  bidIncrement: any = 0;
  canOverrideBidIncrement: boolean = false;
  reservePrice: any = 0;
  canOverrideReservePrice: boolean = false;
  buyNowPrice: any = 0;
  canOverrideBuyNowPrice: boolean = false;
  companyId: number = 0;
  isChecked: boolean = false;
  productMarketplaceListingId: number = 0;
}
